import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Vote } from "lucide-react";
import api from "@/lib/api";
import { PageHero, Loading, Empty } from "@/components/common";

export default function Consultations() {
  const [items, setItems] = useState(null);

  useEffect(() => { api.get("/consultations").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div data-testid="consultations-page">
      <PageHero label="Encuestas" title="Encuestas ciudadanas"
        subtitle="Cada encuesta muestra contexto neutral, argumentos a favor y en contra, fuentes y metodología. Los resultados reflejan a usuarios verificados de 2Voto, no a toda la población." />
      <div className="max-w-6xl mx-auto px-6 py-12">
        {items === null ? <Loading /> : items.length === 0 ? <Empty /> : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {items.map((c) => (
              <Link key={c.id} to={`/consultas/${c.id}`} data-testid={`consultation-card-${c.id}`}
                className="block bg-white rounded-lg border border-slate-200 p-6 hover:shadow-md hover:-translate-y-1 transition-all duration-200">
                <div className="flex items-center justify-between mb-3">
                  {c.category && <span className="text-xs font-semibold text-cyan-600 uppercase tracking-wide">{c.category}</span>}
                  <span className="inline-flex items-center gap-1 text-xs text-slate-400"><Vote className="w-3.5 h-3.5" /> {c.total_votes}</span>
                </div>
                <h3 className="font-heading font-bold text-xl text-slate-900 mb-3">{c.title}</h3>
                <p className="text-slate-600 text-sm line-clamp-3">{c.context}</p>
                <span className="inline-block mt-4 text-sm font-semibold text-cyan-600">Participar →</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
